<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
    <slot />
    <g fill="none" fill-rule="evenodd">
      <circle cx="9" cy="9" r="8.5" :stroke="color" />
      <ellipse cx="9" cy="9" :stroke="color" rx="3.5" ry="8.5" />
      <path :fill="color" d="M1 5H17V6H1zM1 12H17V13H1z" />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    color: String,
  },
};
</script>
